import UPDATE_COLLECTION_VISIBILITY_MUTATION from 'Root/Pages/Collection/Edit/Type/update-collection.graphql'
import UPDATE_CONTENT_VISIBILITY_MUTATION from 'Root/Pages/Content/Edit/Type/update-content.graphql'

import { Fragment } from 'react'

import { Visibility } from 'globalTypes'

import { useMutation } from '@apollo/client'
import { Dialog, Transition } from '@headlessui/react'

import ShareOptions from './ShareOptions'
import styles from './index.module.css'

interface ShareVisibilityProps {
  elementType: 'collection' | 'content'
  id: string
  isOpen: boolean
  onClose: () => void
  onConfirm: (visibility: Visibility) => void
  visibility: Visibility
}

const ShareVisibility = ({
  elementType,
  id,
  isOpen,
  onClose,
  onConfirm,
  visibility,
}: ShareVisibilityProps) => {
  const [updateCollection] = useMutation(
    UPDATE_COLLECTION_VISIBILITY_MUTATION,
    {
      refetchQueries: [
        'GetElementVisibility',
        'GetSharedElementVisibility',
        'GetShareOrCopyElementVisibility',
      ],
    }
  )
  const [updateContent] = useMutation(UPDATE_CONTENT_VISIBILITY_MUTATION, {
    refetchQueries: [
      'GetElementVisibility',
      'GetSharedElementVisibility',
      'GetShareOrCopyElementVisibility',
    ],
  })

  const updateElementVisibility = async (visibility: Visibility) => {
    const mutationVariables = {
      id: id,
      input: { visibility: visibility },
    }

    if (elementType === 'collection') {
      await updateCollection({
        variables: mutationVariables,
      })
    } else {
      await updateContent({
        variables: mutationVariables,
      })
    }

    onConfirm(visibility)
  }

  return (
    <Transition
      as={Dialog}
      show={isOpen}
      onClose={onClose}
      className={styles.dialogWrapper}
      style={{ zIndex: 2147483003 }}
    >
      <Transition.Child
        as={Fragment}
        enter="ease-out duration-300"
        enterFrom="opacity-0"
        enterTo="opacity-100"
        leave="ease-in duration-200"
        leaveFrom="opacity-100"
        leaveTo="opacity-0"
      >
        <div className={styles.dialogFrame} />
      </Transition.Child>

      <div className={styles.visibilityTransitionWrapper}>
        <div className={styles.visibilityChildContainer}>
          <Transition.Child
            as={ShareOptions}
            enter={styles.enter}
            enterFrom={styles.enterFrom}
            enterTo={styles.enterTo}
            leave={styles.leave}
            leaveFrom={styles.leaveFrom}
            leaveTo={styles.leaveTo}
            visibility={visibility}
            onClose={onClose}
            onSave={updateElementVisibility}
          />
        </div>
      </div>
    </Transition>
  )
}

export default ShareVisibility
